import { getUnixTimestampUTC, createElementId, textEnabledDefaults, canvasElementPrefix } from "../util/utils";
import { ElementTextProperties } from "./canvas-element";
import { Point } from "./schemas/canvas-element";
import { TaskElement } from "./schemas/task";
import consts from "shared/consts";

export const TASK_WIDTH = 275;
export const TASK_HEIGHT = 80;
export const TASK_HEIGHT_WITH_INFO = 120;

export const taskPrefix = `${canvasElementPrefix}task-`;

export type TaskInitOptions = {
  text?: string;
  color?: string;
  title?: string;
  description?: string;
} & ElementTextProperties;

export function placeTask(point: Point, init: TaskInitOptions) {
  const {
    text = "",
    color = "#FFFFFF",
    title = "",
    description = "",
    font = textEnabledDefaults.font,
    fontSize = 12, // In contrast to usual 16
    align = "left",
    textColor = "#1E1E1E", // Also not default
    fontProps = textEnabledDefaults.fontProps,
  } = init;

  return {
    id: createElementId(),
    task: {
      // ---- general canvas element props ----
      type: consts.CANVAS_ELEMENTS.TASK,
      x: point.x,
      y: point.y,
      scaleX: 1,
      scaleY: 1,
      hidden: false,
      attachedConnectors: {},
      zIndexLastChangeTime: getUnixTimestampUTC(),
      // ---- text enabled props ----
      text,
      textColor,
      fontSize,
      align,
      fontProps,
      font,
      // ---- task props ----
      title,
      description,
      fill: color,
      width: TASK_WIDTH,
      height: TASK_HEIGHT,
    } as TaskElement,
  };
}
